import * as EditorActions from "./editorActions";

export default EditorActions;



// WEBPACK FOOTER //
// ./src/actions/EditorActions/index.js